export default {
  notFound: {
    title: 'Page not found',
    description: "The page you're looking for doesn't exist or has moved. Try browsing the catalog instead.",
    backHome: 'Back home',
    browseCatalog: 'Browse catalog',
  },
  forbidden: {
    title: "You don't have permission",
    description: "You're signed in, but this page is off-limits. If you think this is a mistake, contact support.",
    backHome: 'Back home',
    contactSupport: 'Contact support',
  },
  server: {
    maintenance: "We'll be right back",
    maintenanceDetail: 'GladKey is briefly offline for maintenance. Please check back in a few minutes.',
    generic: 'Something went wrong',
    genericDetail: "An unexpected error occurred. We've been notified — please try again.",
    unavailable: "We're having trouble connecting",
    unavailableDetail: 'Our service is temporarily unavailable. Try again in a moment.',
    retry: 'Retry',
    backHome: 'Back home',
  },
};
